import { usePlans } from "../PlansContext";

// Legacy professional plans (professional_june_2025 and earlier) had 30 hosts and 20 stream hours.
// Communities grandfathered on these plans should see the same limits reflected in the Business
// column, since upgrading preserves their legacy limits rather than applying the new plan defaults.
const LEGACY_PROFESSIONAL_HOSTS = 30;
const LEGACY_PROFESSIONAL_HOURS = 20;

export const useLiveStreamLimitValues = () => {
  const { compareTablePlanFeatures } = usePlans();

  const professionalHosts =
    compareTablePlanFeatures?.professional?.live_stream_max_host_capacity;

  const professionalHours =
    compareTablePlanFeatures?.professional?.live_stream_monthly_stream_hours;

  const businessHosts =
    professionalHosts === LEGACY_PROFESSIONAL_HOSTS
      ? LEGACY_PROFESSIONAL_HOSTS
      : compareTablePlanFeatures?.business?.live_stream_max_host_capacity;

  const businessHours =
    professionalHours === LEGACY_PROFESSIONAL_HOURS
      ? LEGACY_PROFESSIONAL_HOURS
      : compareTablePlanFeatures?.business?.live_stream_monthly_stream_hours;

  return { professionalHosts, businessHosts, professionalHours, businessHours };
};
